/* jshint -W024 */
import Vue from "vue";

// =========================
// COMPONENTS
// =========================

// BASE
import LazyImg from "./app/eros/components/common/LazyImg.vue";
import Intersect from "./app/ceres/components/common/Intersect.vue";
import TabList from "./app/eros/components/common/TabList.vue";
import TabItem from "./app/ceres/components/common/TabItem.vue";
import LazyLoad from "./app/ceres/components/common/LazyLoad.vue";
import AbtestCurtain from "./app/eros/components/common/AbtestCurtain.vue";

import ReCaptcha from "./app/ceres/components/customer/ReCaptcha.vue";
// legacy non-shopbuilder component
import UserLoginHandler from "./app/eros/components/customer/login/UserLoginHandler.vue";

import CategoryItem from "./app/eros/components/itemList/CategoryItem.vue";
import ItemSearch from "./app/eros/components/itemList/ItemSearch.vue";

import CookieBar from "./app/eros/components/pageDesign/CookieBar.vue";
import Carousel from "./app/ceres/components/pageDesign/Carousel.vue";
import Icon from "./app/eros/components/pageDesign/Icon.vue";
import LanguageDetection from "./app/eros/components/pageDesign/LanguageDetection.vue";
import MobileNavigation from "./app/eros/components/pageDesign/MobileNavigation.vue";
import Notifications from "./app/ceres/components/pageDesign/Notifications.vue";
import Popper from "./app/eros/components/pageDesign/Popper.vue";
import LoadingAnimation from "./app/ceres/components/pageDesign/LoadingAnimation.vue";

import WishListCount from "./app/ceres/components/wishList/WishListCount.vue";

import SingleItem from "./app/eros/components/item/SingleItem.vue";
import SingleItemSetComponent from "./app/ceres/components/item/SingleItemSetComponent.vue";

// EXTERNAL
import LazyHydrate from "vue-lazy-hydration";
import ClientOnly from "./app/ceres/components/common/ClientOnly.vue";
import script2 from "./app/ceres/plugins/script2";

// =========================
// SERVICES
// =========================
import TranslationService from "./app/ceres/services/TranslationService";

// =========================
// MIXINS
// =========================
import "./app/ceres/mixins/template.mixin";
import "./app/ceres/mixins/getJsonData.mixin";

// =========================
// DIRECTIVES
// =========================
import "./app/ceres/directives/basket/basketItemQuantity";
import "./app/ceres/directives/basket/basketItemSum";
import "./app/ceres/directives/basket/toggleBasketPreview";
import "./app/ceres/directives/category/openFilterToolbar";
import "./app/ceres/directives/common/truncateTooltip";
import "./app/eros/directives/customer/logout";
import "./app/eros/directives/helper/populateStoreItem";
import "./app/ceres/directives/helper/validate";
import "./app/ceres/directives/helper/waitingAnimation";
import "./app/eros/directives/helper/waitingAnimationInfinite";
import "./app/eros/directives/helper/mutationObserver";
import "./app/ceres/directives/navigation/navigationTouchHandler";
import "./app/eros/directives/navigation/openMobileNavigation";
import "./app/eros/directives/header/openLanguageControl";
import "./app/ceres/directives/pageDesign/scrollToTop";
import "./app/ceres/directives/pageDesign/stickInParent";
import "./app/eros/directives/navigation/sidenavigationChildrenLoader";
import "./app/eros/directives/pageDesign/tooltip";

// =========================
// FILTERS
// =========================
import "./app/ceres/filters/ageRestriction.filter";
import "./app/ceres/filters/arrayFirst.filter";
import "./app/ceres/filters/attachText.filter";
import "./app/eros/filters/currency.filter";
import "./app/ceres/filters/date.filter";
import "./app/ceres/filters/fileName.filter";
import "./app/ceres/filters/fileUploadPath.filter";
import "./app/ceres/filters/graduatedPrice.filter";
import "./app/ceres/filters/hasItemDefaultPrice.filter";
import "./app/ceres/filters/inputUnit.filter";
import "./app/ceres/filters/itemBundleName.filter";
import "./app/ceres/filters/itemCrossPrice.filter";
import "./app/ceres/filters/itemImage.filter";
import "./app/ceres/filters/itemImageHeight.filter";
import "./app/ceres/filters/itemImageWidth.filter";
import "./app/ceres/filters/itemImageAlternativeText.filter";
import "./app/ceres/filters/itemImages.filter";
import "./app/ceres/filters/itemName.filter";
import "./app/ceres/filters/itemPrice.filter";
import "./app/ceres/filters/itemUrl.filter";
import "./app/ceres/filters/numberFormat.filter";
import "./app/ceres/filters/propertySurcharge.filter";
import "./app/ceres/filters/propertyFileUrl.filter";
import "./app/ceres/filters/translate.filter";
import "./app/ceres/filters/truncate.filter";
import "./app/eros/filters/itemImagesUrlOverwrite.filter";

// =========================
// EROS
// =========================
import TimeLeftToOrder from "./app/eros/components/item/TimeLeftToOrder.vue";
import CategoryContent from "./app/eros/components/common/CategoryContent.vue";
import Prefetch from "./app/eros/components/common/Prefetch.vue";
import DynamicItemList from "./app/eros/components/itemList/dynamicItemList/DynamicItemList.vue";

// async import by default
// import Registration from "./app/eros/components/customer/Registration.vue";
// import ForgotPassword from "./app/eros/components/customer/login/ForgotPassword.vue";
// import Login from "./app/eros/components/customer/login/Login.vue";
import BackgroundImg from "./app/ceres/components/common/BackgroundImg.vue";
// import ShippingCountrySelect from "./app/eros/components/pageDesign/ShippingCountrySelect.vue";
import AddItemToBasketOverlay from "./app/ceres/components/basket/AddItemToBasketOverlay.vue";
import GraduatedPrices from "./app/ceres/components/item/GraduatedPrices.vue";
import ItemPrice from "./app/eros/components/item/ItemPrice.vue";
import ItemAvailability from "./app/eros/components/item/ItemAvailability.vue";
import AddToBasket from "./app/eros/components/basket/AddToBasket.vue";
import AddToWishList from "./app/ceres/components/item/AddToWishList.vue";
import ItemImageCarousel from "./app/eros/components/item/ItemImageCarousel.vue";
import FeedbackAverage from "./app/eros/plugins/plentymarkets/feedback/components/item/FeedbackAverage.vue";
import FeedbackContainer from "./app/eros/plugins/plentymarkets/feedback/components/item/singleitem/FeedbackContainer.vue";
import VariationSelect from "./app/eros/components/item/VariationSelect.vue";
import SingleAddToBasket from "./app/eros/components/item/SingleAddToBasket.vue";
import ItemDataTable from "./app/eros/components/item/ItemDataTable.vue";
import QuantityInput from "./app/eros/components/item/QuantityInput.vue";
import BrevoNewsletterForm from "./app/eros/components/common/BrevoNewsletterForm.vue";

export function beforeCreate() {
	// =========================
	// COMPONENTS
	// =========================

	// BASE
	Vue.component("add-item-to-basket-overlay", AddItemToBasketOverlay);
	Vue.component("add-to-basket", AddToBasket);
	Vue.component("basket-preview", () => import("./app/eros/components/basket/BasketPreview.vue"));
	Vue.component("basket-totals", () => import("./app/eros/components/basket/BasketTotals.vue"));
	Vue.component("coupon", () => import("./app/eros/components/basket/Coupon.vue"));
	Vue.component("basket-list", () => import("./app/eros/components/basket/list/BasketList.vue"));
	Vue.component("step-by-step-navigation", () => import("./app/eros/components/category/StepByStepNavigation.vue"));
	Vue.component("google-maps-widget", () => import("./app/ceres/components/common/GoogleMaps.vue"));
	Vue.component("lazy-img", LazyImg);
	Vue.component("intersect", Intersect);
	Vue.component("tab-list", TabList);
	Vue.component("tab-item", TabItem);
	Vue.component("last-seen-item-list", () => import("./app/ceres/components/containers/LastSeenItemList.vue"));
	Vue.component("change-email-form", () => import("./app/ceres/components/customer/ChangeEmailForm.vue"));
	Vue.component("recaptcha", ReCaptcha);
	Vue.component("registration", () => import("./app/eros/components/customer/Registration.vue"));
	Vue.component("reset-password-form", () => import("./app/eros/components/customer/ResetPasswordForm.vue"));
	Vue.component("forgot-password-modal", () => import("./app/eros/components/customer/login/ForgotPassword.vue"));
	Vue.component("guest-login", () => import("./app/eros/components/customer/login/GuestLogin.vue"));
	Vue.component("login", () => import("./app/eros/components/customer/login/Login.vue"));
	Vue.component("login-view", () => import("./app/eros/components/customer/login/LoginView.vue"));
	Vue.component("user-login-handler", UserLoginHandler);
	Vue.component("item-bundle", () => import("./app/ceres/components/item/ItemBundle.vue"));
	Vue.component("quantity-input", QuantityInput);
	Vue.component("tag-list", () => import("./app/ceres/components/item/TagList.vue"));
	Vue.component("category-item", CategoryItem);
	Vue.component("item-search", ItemSearch);
	Vue.component("search-suggestion-item", () => import("./app/ceres/components/itemList/SearchSuggestionItem.vue"));
	Vue.component("live-shopping-item", () => import("./app/ceres/components/liveShopping/LiveShoppingItem.vue"));
	Vue.component("newsletter-input", () => import("./app/ceres/components/newsletter/NewsletterInput.vue"));
	Vue.component("newsletter-unsubscribe-input", () =>
		import("./app/ceres/components/newsletter/NewsletterUnsubscribeInput.vue")
	);
	Vue.component("order-return", () => import("./app/eros/components/orderReturn/OrderReturn.vue"));
	Vue.component("cookie-bar", CookieBar);
	Vue.component("privacy-settings", () => import("./app/ceres/components/pageDesign/PrivacySettings.vue"));
	Vue.component("carousel", Carousel);
	Vue.component("icon", Icon);
	Vue.component("language-detection", LanguageDetection);
	Vue.component("mobile-navigation", MobileNavigation);
	Vue.component("notifications", Notifications);
	Vue.component("popper", Popper);
	Vue.component("shipping-country-select", () =>
		import("./app/eros/components/pageDesign/ShippingCountrySelect.vue")
	);
	Vue.component("loading-animation", LoadingAnimation);
	Vue.component("wish-list", () => import("./app/ceres/components/wishList/WishList.vue"));
	Vue.component("wish-list-count", WishListCount);
	Vue.component("lazy-load", LazyLoad);
	Vue.component("abtest-curtain", AbtestCurtain);
	Vue.component("add-to-wish-list", AddToWishList);
	Vue.component("graduated-prices", GraduatedPrices);
	Vue.component("item-data-table", ItemDataTable);
	Vue.component("item-image-carousel", ItemImageCarousel);
	Vue.component("item-price", ItemPrice);
	Vue.component("set-price", () => import("./app/ceres/components/item/SetPrice.vue"));
	Vue.component("order-property-list", () => import("./app/ceres/components/item/OrderPropertyList.vue"));
	Vue.component("variation-select", VariationSelect);
	Vue.component("item-availability", ItemAvailability);
	Vue.component("single-item-bundle", () => import("./app/ceres/components/item/SingleItemBundle.vue"));
	Vue.component("item-manufacturer", () => import("./app/ceres/components/item/ItemManufacturer.vue"));
	Vue.component("item-manufacturer-data-list", () => import("./app/ceres/components/item/ItemManufacturerDataList.vue"));
	Vue.component("item-eu-responsible-data-list", () => import("./app/ceres/components/item/ItemEuResponsibleDataList.vue"));
	Vue.component("manufacturer-details", () => import("./app/ceres/components/item/ManufacturerDetails.vue"));
	Vue.component("eu-responsible-details", () => import("./app/ceres/components/item/EuResponsibleDetails.vue"));
	Vue.component("single-add-to-basket", SingleAddToBasket);
	Vue.component("set-quantity-input", () => import("./app/ceres/components/item/SetQuantityInput.vue"));
	Vue.component("single-item", SingleItem);
	Vue.component("single-item-set-component", SingleItemSetComponent);
	Vue.component("form-attachment", () => import("./app/ceres/components/form/FormAttachment.vue"));
	Vue.component("client-only", ClientOnly);
	Vue.component("background-img", BackgroundImg);

	// EROS
	Vue.component("exchange-rate", () => import("./app/eros/components/common/ExchangeRate.vue"));
	Vue.component("dynamic-item-list", DynamicItemList);
	Vue.component("dynamic-item-list-common", () =>
		import("./app/eros/components/itemList/dynamicItemList/Common/DynamicItemListCommon.vue")
	);
	// since basket isn't tpl.basket
	Vue.component("dynamic-item-list-basket-tag", () =>
		import("./app/eros/components/itemList/dynamicItemList/Basket/DynamicItemListBasketTag.vue")
	);
	Vue.component("dynamic-item-list-basket-prop", () =>
		import("./app/eros/components/itemList/dynamicItemList/Basket/DynamicItemListBasketProp.vue")
	);
	Vue.component("dynamic-item-list-basket-simple", () =>
		import("./app/eros/components/itemList/dynamicItemList/Basket/DynamicItemListBasketSimple.vue")
	);
	Vue.component("event-tracker", () => import("./app/eros/components/common/EventTracker.vue"));
	Vue.component("category-content", CategoryContent);
	Vue.component("prefetch", Prefetch);
	Vue.component("time-left-to-order", TimeLeftToOrder);
	Vue.component("add-article-notification", () => import("./app/eros/components/item/AddArticleNotification.vue"));
	Vue.component("dynamic-item-list-item-tag", () =>
		import("./app/eros/components/itemList/dynamicItemList/Item/DynamicItemListItemTag.vue")
	);
	Vue.component("dynamic-item-list-item-attr-cross", () =>
		import("./app/eros/components/itemList/dynamicItemList/Item/DynamicItemListItemAttrCross.vue")
	);
	Vue.component("dynamic-item-list-item-variation-session", () =>
		import("./app/eros/components/itemList/dynamicItemList/Item/DynamicItemListItemVariationSession.vue")
	);
	Vue.component("brevo-newsletter-form", BrevoNewsletterForm);

	// EXTERNAL
	Vue.component("lazy-hydrate", LazyHydrate);
	Vue.use(script2);

	// Plugin Feedback
	Vue.component("FeedbackAverage", FeedbackAverage);
	Vue.component("FeedbackContainer", FeedbackContainer);
	Vue.component("FeedbackOrderContainer", () =>
		import("./app/eros/plugins/plentymarkets/feedback/components/order/FeedbackOrder.vue")
	);

	Vue.prototype.$translate = TranslationService.translate;
	Vue.prototype.$ceres = App;
}

export function createApp(options, store) {
	const defaultOptions = {
		store,
		...options,
		data: () => {
			return { prefetch: false };
		}
	};

	const app = new Vue(defaultOptions);

	return app;
}
